module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/signSuccess.7574446e.svg";